var _defs, _g, _path, _rect, _polygon, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Copy",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 366.28 524.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_48",
    "data-name": "Layer 48"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "319.61 394.56 315.21 132.54 237.71 59 36.46 61.2 36.46 365.06 66.84 366.38 67.28 394.56"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M327.66,401.09H59.07V76.74H267.13l-1.05,55.84,61.58.48ZM75.25,384.92H311.49V149.11l-61.89-.48,1.05-55.71H75.25Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 283.57,
    y: 69.84,
    width: 16.18,
    height: 82.2,
    transform: "translate(13.04 251.45) rotate(-47.59)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "67.16 375.44 28.43 375.44 28.43 51.09 242.1 51.09 291.38 99.75 280.01 111.26 235.46 67.27 44.6 67.27 44.6 359.26 67.16 359.26 67.16 375.44"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 108.01,
    y: 234.32,
    width: 171.4,
    height: 19.93,
    transform: "matrix(0, -1, 1, 0, -51.42, 436.92)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 183.74,
    y: 158.59,
    width: 19.93,
    height: 171.4,
    transform: "translate(-51.42 436.93) rotate(-89.75)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.3f81ed9ffbb500fe33d44de84b822912.svg";
export { ForwardRef as ReactComponent };